import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";
import ContentSection from "./contentSection";

//IMAGES
import MainPhoto from "./images/Main Photo.png";

function Home(props) {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    useEffect(() => {
        console.log(props.image);
    }, []);

    return (
        <div style={{ ...SectionsStyles.backgroundPicture, backgroundImage: `url('/content/mainStyle/sectionsBackgrounds/${props.image}')` }}>
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons downText={"Meet The Team"} />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={0} nav={"home"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
